import { GeneralSearchParms } from '../../shared/search-params';


export interface PatientOrderParms extends GeneralSearchParms {
  day?: Date;
  serviceType?: number;
  patientCode?: number;
  serviceCode?: number;
  orderMasterSerial?: number;
  serviceParentcode?: number;
  serviceStatus?: number;
  patSampleId?: number;
  workflowAppCode?: number;
  visitSerial?: number;
  regPatServiceSerial?: number;
  orderDetailSerial: number;
  fastSearchData?: string,
  invoiceDate?: Date;
  docCode?: number;
  serviceStatusArr?: string
  referalDocCode?: number,
  companyType?: number;
  companyCode?: number;
  floorCode?: number;
  nutritionTypeSerial?: number;
}
export interface NursingDashboardParms {
  serial?: number,
  fromDate?: Date,
  toDate?: Date,
  type?: number,
  refrenceSerial?: number
  patCode?: number,
  dataStatus?: number,
  notes?: string
  colorCode?: number

}


export interface OrderPatServiceVm {
  regPatServiceSerial?: number;
  resultWriteDate?: Date;
  visitSerial?: number;
  collectedDate?: Date;
  orderMasterSerial?: number;
  orderDetailSerial?: number;
  customServiceCode?: number;
  serviceCode?: number;
  identityValue?: number;
  serviceNameAr?: string;
  serviceNameEn?: string;
  patientNameAr?: string;
  patientNameEn?: string;
  VisitTypeNameAr?: string,
  VisitTypeNameEn?: string,
  ServiceParentNameAr?: string,
  ServiceParentNameEn?: string,
  doctorDoAr?: string,
  doctorDoEn?: string,
  visitTypeAr?: string,
  visitTypeEn?: string,
  patientAge?: number;
  patientBirthDate?: Date;
  orderDate?: Date;
  orderTime?: Date;
  orderNumber?: number;
  OrderPlace?: number;
  patientCode?: number;
  serviceStatus?: number;
  serviceStatusNameAr?: string;
  serviceStatusNameEn?: string;
  updateStatus?: boolean;
  expectedEndTime?: Date;
  patCode?: number;
  doctorNameAr?: string;
  doctorNameEn?: string;
  serviceType?: number;
  placeNameAr?: null;
  placeNameEn?: null;
  expectedStartTime?: Date;
  birthDate?: Date;
  visitNo?: number;
  labSampleTypeCode?: number;
  execuetedOutSideHosp?: number;
  workflowType?: number;
  sampleExpiryNameAr?: number;
  sampleExpiryNameEn?: number;
  sampleExpiryQty?: number;
  sampleParCode?: string;
  price?: number;
  supplierCode?: number;
  appCodes?: Array<number>;
  ageAr?: string;
  ageEn?: string;
  addressAr?: string,
  addressEn?: string,
  religion_name_ar?: string,
  religion_name_en?: string,
  technicianNamEn?: string,
  mailAddress?: string,
  contractsAr?: string;
  contractsEn?: string;
  mobile?: number;
  hr_EmpMainDataCode?: number;
  printedCount?: number;
  sampleId?: number;
  rowsCount?: number;
  deleveryType?: number;
  currentlySelected: boolean;
  written: boolean;
  gender?: string;
  invSer?: number;
  docCode?: number;
  linkPath?: string;
  referalAr?: string;
  delayOrFollowUp?: number;
  width?: number;
  height?: number;
  regPatServSerial?: number;
  phoneNumber?: string
}

export interface DeliverResult {
  serial?: number;
  type?: number;
  text?: string;
  regPatServiceSerial?: number;
  dataStatus?: number;
}

export class OrderPatientAction {
  public static Order_Pat_Service: string = 'Order_Pat_Service';
  public static Order_Next_AppCode: string = 'Order_Next_AppCode';
  public static Order_Update_Service_Status: string = 'Order_Update_Service_Status';
  public static Order_Col_Samp_Emp: string = 'Order_Col_Samp_Emp';
  // public static Order_Pat_Service_Multi: string = 'Order_Pat_Service_Multi';
  // public static Order_Service_Mode_Type: string = 'Order_Servcie_Mode_Type';
  public static Order_Work_Flow: string = 'Order_Work_Flow';
  public static Order_Patient_Sevices_With_Same_Status: string = 'Order_Patient_Sevices_With_Same_Status';// used to get all service with same status from code not from users selections in write and review steps

  public static Order_Deliver_Result = 'Order_Deliver_Result';
  public static Order_Workflow_Change = 'Order_Workflow_Change';
  public static Order_Hide_Show_Workflow = 'Order_Hide_Show_workflow';
  public static Order_Filtered_App_Code = 'Order_Filtered_App_Code';
  public static Order_Full_Workflow = 'Order_Full_Workflow';
  public static Order_All_Workflows = 'Order_All_Workflows';
  public static Order_Permission_AppCodes = 'Order_Permission_AppCodes';
}

// export const OrderPatientAction ={
//     Order_Pat_Service : 'Order_Pat_Service',
//     Order_Next_AppCode : 'Order_Next_AppCode',
//     Order_Update_Service_Status : 'Order_Update_Service_Status',
//     Order_Col_Samp_Emp : 'Order_Col_Samp_Emp',
//     Order_Pat_Service_Multi : 'Order_Pat_Service_Multi',
//     Order_Service_Mode_Type : 'Order_Servcie_Mode_Type',
//     Order_Work_Flow : 'Order_Work_Flow',
//     Order_Patient_Sevices_With_Same_Status : 'Order_Patient_Sevices_With_Same_Status'
// }
